// src/views/HomeView.js

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import GearIcon from '../components/Shared/GearIcon';
import { QUIZ_LISTS } from '../config/quizLists';
import { useSettings } from '../components/Settings/SettingsContext';

const Home = () => {
    const { isLearningMode } = useSettings();
    const [quizCounts, setQuizCounts] = useState({});

    useEffect(() => {
        QUIZ_LISTS.forEach(list => {
            fetch(`/data/${list.file}`)
                .then(res => res.json())
                .then(data => {
                    setQuizCounts(prev => ({
                        ...prev,
                        [list.id]: data.length
                    }));
                })
                .catch(() => {
                    setQuizCounts(prev => ({
                        ...prev,
                        [list.id]: '?'
                    }));
                });
        });
    }, []);

    const pytaniaLabel = (count) => {
        if (count === 1) return 'pytanie';
        if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100)) return 'pytania';
        return 'pytań';
    };

    return (
        <div style={{ position: 'relative' }}>
            <Link
                to="/settings"
                style={{
                    position: 'absolute',
                    top: 16,
                    right: 16,
                    zIndex: 10,
                    textDecoration: 'none'
                }}
            >
                <button
                    aria-label="Ustawienia"
                    style={{
                        fontSize: 24,
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        padding: 6,
                        borderRadius: '50%',
                        color: '#222'
                    }}
                >
                    <GearIcon size={24} color="#222" />
                </button>
            </Link>

            <h1>Wybierz quiz</h1>
            <ul>
                {QUIZ_LISTS.map(list => (
                    <li key={list.id}>
                        <Link
                            to={
                                isLearningMode
                                    ? `/learn/${list.id}`
                                    : `/quiz/${list.id}`
                            }
                        >
                            {list.label}
                            {' '}
                            {quizCounts[list.id] === undefined
                                ? '(ładowanie...)'
                                : quizCounts[list.id] === '?'
                                    ? '(błąd)'
                                    : `(${quizCounts[list.id]} ${pytaniaLabel(quizCounts[list.id])})`
                            }
                        </Link>
                    </li>
                ))}
            </ul>
            <div>
                <Link to="/all-questions">
                    <button>Zobacz wszystkie pytania</button>
                </Link>
            </div>
        </div>
    );
};

export default Home;
